import { withInstall } from '../../../utils/with-install'
import ThreeLightDirectional from './ThreeLightDirectional.vue'

export const ElAmapThreeLightDirectional = withInstall(ThreeLightDirectional)
export default ElAmapThreeLightDirectional
